import { render, staticRenderFns } from "./AttemptsListComponent.vue?vue&type=template&id=5a954e9d&"
import script from "./AttemptsListComponent.vue?vue&type=script&lang=js&"
export * from "./AttemptsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports